module.exports = __webpack_public_path__ + "static/manifest-bg-9deeffb8aa7a57593af1a08ffe8a10cb.jpg";